import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Space, Note } from '../models/space.model';

export interface ModalConfig {
  type: 'create-space' | 'add-note' | 'delete-space' | null;
  data?: Partial<Space>;
  spaceId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private readonly modalSubject = new BehaviorSubject<ModalConfig>({ type: null });
  private readonly noteAddedSubject = new Subject<{ spaceId: string; note: Note }>();
  
  modal$ = this.modalSubject.asObservable();
  noteAdded$ = this.noteAddedSubject.asObservable();

  openCreateSpaceModal(spaceData?: Partial<Space>): void {
    this.modalSubject.next({ type: 'create-space', data: spaceData });
  }

  openAddNoteModal(spaceId: string): void {
    this.modalSubject.next({ type: 'add-note', spaceId });
  }

  openDeleteSpaceModal(spaceId: string): void {
    this.modalSubject.next({ type: 'delete-space', spaceId });
  }

  closeModal(): void {
    this.modalSubject.next({ type: null });
  }

  emitNoteAdded(spaceId: string, note: Note): void {
    this.noteAddedSubject.next({ spaceId, note });
  }
}
